import { profilePics } from "utils/ProfilePics";

const isBrowser = typeof window !== "undefined";
const isLocalhost =
  isBrowser &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const REACT_APP_SERVER_LINK =
  (process.env.REACT_APP_SERVER_LINK as string) || (isLocalhost ? "http://localhost:8000" : "");

const REACT_APP_HOSTED_LINK = (process.env.REACT_APP_HOSTED_LINK as string) || "";

export { profilePics, REACT_APP_SERVER_LINK, REACT_APP_HOSTED_LINK };
